import { ProductModelService } from 'ngx-core-services';

/** Inverter version for G3 / Product D devices (different register layout) */
export const INVERTER_VERSION_G3 = 3;

/**
 * Resolve inverter version from serial number.
 * Product D inverters use version 3 (different register layout).
 */
export function resolveInverterVersion(serial: string): number | undefined {
  return new ProductModelService(serial).isProductD ? INVERTER_VERSION_G3 : undefined;
}
